import React from 'react'

import { Toaster } from 'react-hot-toast'

interface TrackingButtonProps {
  companyColor: string
  text: string
  dark: boolean
  disabled?: boolean
  onClick: () => void
}

const Button: React.FC<TrackingButtonProps> = ({ companyColor, text, dark, onClick, disabled = false }: TrackingButtonProps) => {
  const bgColor = disabled ? 'lightgray' : companyColor
  const textColor = disabled ? 'black' : 'white'

  return (
    <div className="h-full flex max-[632px]:w-full max-[632px]:justify-center">
      <div
        className="rounded-xl w-full cursor-pointer md:w-full"
        style={{ backgroundColor: dark ? bgColor : 'transparent', color: dark ? textColor : companyColor }}
      >
        <button
          type="button"
          onClick={onClick}
          tabIndex={0}
          className="flex justify-center items-center font-medium h-full w-full"
          disabled={disabled}
        >
          {text}
        </button>
      </div>

      <Toaster />
    </div>
  )
}

export default Button
